import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/anime';

const navLinks = [
  { name: '首页', path: '/', icon: 'ri-home-5-line' },
  { name: '动漫分类', path: '/category', icon: 'ri-layout-grid-line' },
  { name: '新番资讯', path: '/articles', icon: 'ri-newspaper-line' },
  { name: '关于我们', path: '/about', icon: 'ri-team-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [mobileCat, setMobileCat] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setMobileCat(false);
  }, [location.pathname]);

  const submitSearch = () => {
    const kw = keyword.trim();
    if (kw) navigate(`/category?q=${encodeURIComponent(kw)}`);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav
        aria-label="主导航"
        className="mx-auto flex items-center justify-between px-4 md:px-6 py-3"
      >
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="动漫网首页">
          <span
            className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-background-50"
            aria-hidden="true"
          >
            <i className="ri-sword-fill text-lg" />
          </span>
          <span className="font-heading text-2xl text-foreground-950 leading-none">
            动漫<span className="text-primary-600">网</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const active =
              link.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                  active
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={link.icon} aria-hidden="true" />
                {link.name}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <div className="flex items-center gap-2 rounded-full bg-background-100 px-3 py-2">
            <i className="ri-search-line text-foreground-400" aria-hidden="true" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && submitSearch()}
              placeholder="搜索动漫、番剧"
              aria-label="站内搜索"
              className="w-36 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <Link
            to="/category"
            className="flex items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-play-fill" aria-hidden="true" />
            立即看番
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} aria-hidden="true" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="flex items-center gap-2 rounded-lg px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
            >
              <i className={link.icon} aria-hidden="true" />
              {link.name}
            </Link>
          ))}
          <button
            type="button"
            onClick={() => setMobileCat(!mobileCat)}
            className="flex w-full items-center justify-between rounded-lg px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
          >
            <span className="flex items-center gap-2">
              <i className="ri-layout-grid-line" aria-hidden="true" />全部分类
            </span>
            <i className={mobileCat ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} aria-hidden="true" />
          </button>
          {mobileCat && (
            <div className="ml-3 grid grid-cols-2 gap-1">
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.id}`}
                  className="rounded-lg px-3 py-2 text-xs text-foreground-600 hover:bg-background-100"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          )}
        </div>
      )}
    </header>
  );
}